<template>
  <HeaderContent title="Reservation" />
  <ActionContent
    ctaText="Add Reservation"
    @action="showModal"
    @showFilter="modalFilter = !modalFilter"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    v-model:search="search"
    @search-query="handleSearch"
  />
  <ReservationStatistic title="Reservation Statistics" :data="statistics" />
  <ReservationForm
    :modal="modal"
    :modalReschedule="modalReschedule"
    :reservationData="reservation"
    @update:reservationData="updateReservation"
    @update:modal="updateModal"
    @update:modalReschedule="updateReschedule"
    @addOrUpdate="getAll"
  />

  <ExtrachargeForm
    :modal="modalExtraCharge"
    :uuid="reservationUuid"
    @update:modal="modalExtraCharge = $event"
    @addedExtraCharge="getAll"
  />

  <ReservationFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
    @filter="handleFilter"
  />
  <!-- <ReservationConfirm
    title="Confirmation"
    :uuid="reservationUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(reservationUuid)"
  >
  <template #text>Are you sure to DELETE this this data ?</template>
  </ReservationConfirm> -->

  <ReservationConfirm
    title="Confirmation"
    :uuid="reservationUuid"
    v-model="modalConfirm"
    @confirmed="handleConfirm"
  >
    <template #text>
      {{ modalType === 'delete' ? 'Are you sure to DELETE this data?' : 'Are you sure to VOID this reservation?' }}
    </template>
  </ReservationConfirm>

  <ReservationDataTable
    :data="reservations"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />

  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import { ref, inject, onMounted, watch } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ReservationStatistic from "@/components/StatisticData.vue";
import ReservationFilter from "./ReservationFilter.vue";
import ReservationForm from "./ReservationForm.vue";
import ReservationDataTable from "@/components/DataTable.vue";
import ReservationConfirm from "@/components/ModalDialog.vue";
import iconVoid from "../../../public/icons/rectangle-xmark.svg";
import iconReserved from "../../../public/icons/receipt.svg";
import iconCheckIn from "../../../public/icons/clipboard-check.svg";
import iconCheckOut from "../../../public/icons/door-open.svg";
import iconOverall from "../../../public/icons/square-poll-vertical.svg";
import ExtrachargeForm from "@/components/Extracharge/ExtrachargeForm.vue";
import ToastResponse from "@/components/ToastResponse.vue";
import {getFormattedDate} from '@/composable/getDateTimeFormatter';
//import axios from 'axios';
//import { reactive } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    ExtrachargeForm,
    ReservationForm,
    ReservationFilter,
    ReservationStatistic,
    ReservationConfirm,
    ReservationDataTable,
    ToastResponse,
  },

  setup() {
    const repositories = inject("repositories");
    const reservationRepository = repositories
      ? repositories.reservations
      : null;

    const modal = ref(false);
    const modalExtraCharge = ref(false);
    const modalReschedule = ref(false);
    const selected = ref(null);
    const reservationUuid = ref(null);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const modalType = ref(''); // untuk menyimpan apakah modal delete atau void
    const currentPage = ref(1);
    const types = ref([]);
    const sources = ref([]);
    const payments = ref(["DP", "Lunas"]);
    const data = ref([]);

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const headers = ref([
      {
        key: "no",
        label: "No",
        sortable: true,
      },
      {
        key: "number",
        label: "Reservation No",
        sortable: true,
      },
      {
        key: "room_category",
        label: "Type",
        sortable: true,
      },
      {
        key: "room.code",
        label: "Number",
        sortable: true,
      },
      {
        key: "status_reservation",
        label: "Status",
        sortable: false,
      },
      {
        key: "guest.fullname",
        label: "Guest Name",
        sortable: true,
      },
      {
        key: "start",
        label: "Arrival",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      
      },
      {
        key: "end",
        label: "Departure",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "days",
        label: "Total Day",
        sortable: true,
      },
      {
        key: "payment_status",
        label: "Payment Status",
        sortable: true,
      },
      {
        key: "pre_payment",
        label: "Prepayment",
        sortable: false,
      },
      {
        key: "grand_total",
        label: "Total Bill",
        sortable: false,
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Add ExtraCharge",
        variant: "warning",
        icon: "fas fa-bolt",
        disabled: (item) => item.status === "Check Out",
        action: (item) => {
          reservationUuid.value = item.uuid;
          modalExtraCharge.value = true;
        },
      },
      {
        label: "Reschedule",
        variant: "orange",
        icon: "fas fa-calendar-day",
        disabled: (item) =>
          item.status === "Check Out" || item.status === "In House",
        action: (item) => {
          reservation.value = item;
          reservationUuid.value = item.uuid;
          modalReschedule.value = true;
        },
      },
      {
        label: "Edit or Reschedule",
        variant: "success",
        icon: "fas fa-edit",
        disabled: (item) => item.status !== "Booked",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Void",
        variant: "danger",
        icon: "fas fa-times",
        disabled: (item) => item.status !== "Booked",
        action: (item) => {
          showConfirmModal(item.uuid, 'void');
          // Implement your delete logic here
        },
      },
      // {
      //   label: "Delete",
      //   variant: "danger",
      //   icon: "fas fa-trash",
      //   action: (item) => {
      //     showConfirmModal(item.uuid);
      //     // Implement your delete logic here
      //   },
      // },
    ]);

    const reservations = ref([]);
    const statistics = ref([]);
    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    //const startDate = ref(getCurrentDate);
    const startDate = ref(getStartDate);
    const endDate = ref(getCurrentDate);

    const search = ref("");
    const filterStatus = ref({
      status: null,
    });
    const reservation = ref({});
    // const formatStatusKey = (statusLabel) => {
    //   if (statusLabel === 'Checkout On') {
    //     return 'checkout_on';
    //   }

    //   return statusLabel.toLowerCase().replace(/\s+/g, '');
    // };

    const getAll = async (
      start = null,
      end = null,
      status = null,
      searchQuery = ""
    ) => {
      const params = {};
      const dateNow = new Date();
      const todayString = dateNow.toISOString().split("T")[0]; // Format: YYYY-MM-DD

      if (start) params.start = start;
      if (end) params.end = end;
      if (status && status !== "All") params.status = status;
      if (searchQuery) params.search = searchQuery;

      try {
        const res = await reservationRepository.getAll(params);
        const allReservations = res.data.data;

        // filter statistic checkin
        const checkInsToday = allReservations.filter((item) => {
          if (!item.start) return false;
          const checkInDate = new Date(item.start).toISOString().split("T")[0];
          return checkInDate === todayString;
        });

        // filter statistic checkout
        const checkOutsToday = allReservations.filter((item) => {
          if (!item.end) return false;
          const checkOutDate = new Date(item.end).toISOString().split("T")[0];
          return checkOutDate === todayString;
        });

        // Hitung statistik status
        const reservedCount = allReservations.filter(
          (item) => item.status === "Booked"
        ).length;

        const voidCount = allReservations.filter(
          (item) => item.status === "Void"
        ).length;

        reservations.value = allReservations;

        statistics.value = [
          {
            label: "Total",
            key: "Reserve",
            //value: res.data.statistics.reserved,
            value: reservedCount, 
            color: "primary",
            icon: iconReserved,
          },
          {
            label: "Total",
            key: "CheckIn Today",
            value: checkInsToday.length, // Ganti dengan hasil filter hari ini
            color: "success",
            icon: iconCheckIn,
          },
          {
            label: "Total",
            key: "CheckOut Today",
            value: checkOutsToday.length,
            color: "warning",
            icon: iconCheckOut,
          },
          {
            label: "Total",
            key: "Void",
            //value: res.data.statistics.void,
            value: voidCount,
            color: "danger",
            icon: iconVoid,
          },
          {
            label: "Total",
            key: "Overall",
            value: res.data.statistics.overall,
            color: "primary",
            icon: iconOverall,
          },
        ];
      } catch (err) {
        console.error(err);
      }
    };
    
    const fetchReservations = async () => {
      await getAll(startDate.value, endDate.value);
    };

    const getById = async (uuid) => {
      await reservationRepository
        .getById(uuid)
        .then((res) => {
          modal.value = true;
          reservation.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const showModal = () => {
      modal.value = true;
      reservation.value = {};
    };
    const updateModal = (newValue) => {
      modal.value = newValue;
      reservation.value = null;
    };

    const updateReschedule = (newValue) => {
      modalReschedule.value = newValue;
      reservation.value = null;
    };

    const updateReservation = (updatedReservation) => {
      reservation.value = updatedReservation;
    };

    const showConfirmModal = async (uuid, type) => {
      reservationUuid.value = uuid;
      modalType.value = type;  // simpan jenis aksi: 'delete' atau 'void'
      console.log("uuid", reservationUuid.value);
      console.log("tipe action", type);
      modalConfirm.value = true;
    };

    const voidData = async(uuid) =>{
      try {
        await reservationRepository
        .void(uuid)
        .then(() => {
          getAll();
          modalConfirm.value = false;
          // modalResponse.value.success = true;
          // modalResponse.value.toast = true;
          // modalResponse.value.text = "ini pesan toast"; // ambil pesan dari backend

          Object.assign(modalResponse.value, {
            toast: true,
            success: true,
            text: "Reservation status updated to VOID", // ambil pesan dari backend
          });

          console.log("nilai Modal Response", modalResponse.value);

        })
        .catch((err) => {
          console.log("pesan error", JSON.stringify(err, null, 2));
          modalResponse.value.text = err.response?.data?.message || "Terjadi kesalahan";
          modalResponse.value.success = false;
          modalResponse.value.toast = true;
        })
        // handle success
        // misal ini endpoint API void
        //alert(response.data.message);
        // refresh data atau update UI sesuai kebutuhan
      }
      catch (err) {
        console.error(err);
      }
      
    }

    const deleteData = async (uuid) => {
      await reservationRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const handleFilter = (filterData) => {
      filterStatus.value = filterData;
      getAll(startDate.value, endDate.value);
    };

    function handleSearch(query) {
      search.value = query;
      getAll(startDate.value, endDate.value, filterStatus.value.status, query);
    }

    function handleConfirm() {
      if (modalType.value === 'delete') {
        deleteData(reservationUuid.value);
      } else if (modalType.value === 'void') {
        voidData(reservationUuid.value);
      }
    }

    watch([startDate, endDate, filterStatus], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value
      );
    });

    onMounted(() => {
      getAll();
      fetchReservations();
    });

    return {
      getAll,
      getById,
      filterStatus,
      handleFilter,
      handleSearch,
      handleConfirm,
      search,
      showModal,
      updateModal,
      updateReservation,
      updateReschedule,
      deleteData,
      getCurrentDate,
      startDate,
      endDate,
      sources,
      selected,
      reservationUuid,
      modal,
      modalExtraCharge,
      modalReschedule,
      modalResponse,
      data,
      headers,
      types,
      payments,
      statistics,
      reservation,
      reservations,
      modalFilter,
      modalConfirm,
      currentPage,
      customActions,
    };
  },
};
</script>
